import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { LiveChatProviderService, URLS } from '@hdms/shared/page-frame/data-access';
import { UserAccountData } from '@hdms/shared/page-frame/types';

import { ContactComponentAbstract } from '../contact-abstract/contact-component.abstract';
import { ContactBodyLoaderService } from '../contact-body/contact-body-loader.service';

@Component({
  selector: 'shrd-pf-ft-contact-footer',
  templateUrl: './contact-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactFooterComponent extends ContactComponentAbstract {
  readonly businessHours$ = inject(ContactBodyLoaderService).loaded$;
  readonly liveChatInitialized$ = inject(LiveChatProviderService).isChatInitialized$;
  readonly storesUrl = URLS.stores;
  readonly isSubmitBtnEnabled$ = inject(ContactBodyLoaderService).isSubmitBtnEnabled$;

  @Input() inModal = false;
  @Input() userData: UserAccountData;
  @Output() closeAction = new EventEmitter<void>();
}
